var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyEventHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 573,
    height: 350,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#36344E",
    d: "M449.508 54.669s-12.611 1.422-13.426 20.952c-.681 16.276-2.066 25.346 4.559 28.741 2.365 1.213 5.148 1.317 7.678.49l27.025-8.886s.405-29.292-8.953-36.413-16.883-4.884-16.883-4.884"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAAFB2",
    d: "m464.405 99.557-13.677 4.498v-19.69h12.409zM422.594 211.321c-.742 4.51-3.751 7.746-6.717 7.225-2.972-.521-4.774-4.602-4.032-9.112.27-1.808.987-3.518 2.083-4.983l3.389-19.07 9.223 1.93-4.32 18.593a11.15 11.15 0 0 1 .374 5.417M453.908 338.131H441.1l-7.433-68.451h19.806z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36344E",
    d: "M428.623 349.13c-1.348 0-2.549-.03-3.45-.116-3.401-.313-6.649-2.825-8.279-4.29a2.32 2.32 0 0 1-.588-2.616 2.32 2.32 0 0 1 1.501-1.33l8.99-2.568 14.56-9.823.166.294c.061.11 1.489 2.684 1.967 4.424.184.662.135 1.214-.141 1.643a1.57 1.57 0 0 1-.674.563c.263.276 1.091.834 3.634 1.238 3.72.589 4.492-3.26 4.529-3.419l.024-.129.11-.073c1.765-1.14 2.856-1.655 3.23-1.545.233.068.625.19 1.679 10.669.104.331.846 2.74.343 5.05-.545 2.512-11.508 1.648-13.702 1.446-.062.006-8.267.588-13.893.588h-.006z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAAFB2",
    d: "M482.851 338.131h-12.814l-7.427-68.451h19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36344E",
    d: "M457.567 349.13c-1.349 0-2.55-.03-3.451-.116-3.401-.313-6.648-2.825-8.279-4.29a2.32 2.32 0 0 1-.588-2.616 2.32 2.32 0 0 1 1.502-1.33l8.989-2.568 14.561-9.823.165.294c.062.11 1.489 2.684 1.967 4.424.184.662.135 1.214-.141 1.643-.19.294-.459.465-.674.563.264.276 1.091.834 3.634 1.238 3.72.589 4.492-3.26 4.529-3.419l.024-.129.111-.073c1.771-1.14 2.855-1.655 3.229-1.545.233.068.625.19 1.679 10.669.105.331.846 2.74.344 5.05-.546 2.512-11.509 1.648-13.703 1.446-.061.006-8.267.588-13.892.588h-.006z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFE0",
    d: "M486.534 170.006h-62.243l22.374-73.635h24.818z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFE0",
    d: "M450.58 96.376s-15.461-.404-17.085 3.665-20.749 100.899-20.749 100.899h12.611L450.58 96.383z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAAFB2",
    d: "M452.419 89.812c7.527 0 13.629-6.101 13.629-13.628s-6.102-13.63-13.629-13.63-13.629 6.102-13.629 13.63c0 7.527 6.102 13.628 13.629 13.628"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36344E",
    d: "M448.693 59.756s-7.501 30.457.84 44.692l-11.748-2.494s-4.553-33.33 4.602-39.391zM473.598 170.006h-40.85l-22.349 91.731c-.411 3.873 2.046 7.489 5.809 8.5 12.262 3.285 41.69 7.936 86.222-5.025 4.284-1.244 6.717-5.767 5.375-10.026z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFE0",
    d: "m457.083 96.37 12.703-.558a17.44 17.44 0 0 1 13.427 8.071c8.977 14.193 25.774 44.104 10.779 48.204-19.769 5.399-29.347-24.66-29.347-24.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAAFB2",
    d: "M452.725 105.28c-2.611-3.751-2.702-8.169-.214-9.867 2.494-1.697 6.63-.024 9.241 3.726a11 11 0 0 1 1.973 5.025l10.853 16.044-7.961 5.043-9.854-16.35a11.1 11.1 0 0 1-4.038-3.621"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFE0",
    d: "m459.147 118.254 8.966-8.248 17.728 16.503-16.484 11.269z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#286795",
    d: "M19.861 77.6H301.3c10.969 0 19.861 8.892 19.861 19.86 0 10.97-8.892 19.862-19.861 19.862H19.861C8.891 117.322 0 108.43 0 97.461S8.892 77.6 19.861 77.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484565",
    d: "M124.59 349.27c0 .405.325.73.73.73h446.915c.405 0 .73-.325.73-.73a.727.727 0 0 0-.73-.729H125.32a.727.727 0 0 0-.73.729"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DFDFE0",
    d: "M260.211 57.574h58.432a2.52 2.52 0 1 1 0 5.038h-58.432a2.52 2.52 0 1 1 0-5.038M2.525 0h58.431a2.52 2.52 0 1 1 0 5.037H2.525a2.52 2.52 0 1 1 0-5.037M2.525 22.006h171.507a2.521 2.521 0 1 1 0 5.043H2.525A2.52 2.52 0 0 1 0 24.531a2.525 2.525 0 0 1 2.525-2.525"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484662",
    d: "M143.256 159.869c0 13.213 10.712 23.924 23.924 23.924 4.002 0 7.771-.98 11.08-2.714l23.183 36.768a4.56 4.56 0 0 0 6.587 1.22 4.56 4.56 0 0 0 .969-6.318l-25.499-35.39c4.675-4.369 7.605-10.589 7.605-17.49 0-13.212-10.712-23.924-23.925-23.924-13.212 0-23.924 10.712-23.924 23.924m3.285 0c0-11.398 9.241-20.645 20.646-20.645 11.404 0 20.645 9.241 20.645 20.645 0 11.399-9.241 20.646-20.645 20.646-11.399 0-20.646-9.241-20.646-20.646"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h572.965v350H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyEventHistory);
export default __webpack_public_path__ + "static/media/emptyEventHistory.c04b674a376113d2b839c8cabfe7292a.svg";
export { ForwardRef as ReactComponent };